export default __webpack_public_path__ + "static/media/hd_logo.13af5a41.png";